import { render, staticRenderFns } from "./EditIntershipNewsPopup.vue?vue&type=template&id=63b7c5a0&scoped=true"
import script from "./EditIntershipNewsPopup.vue?vue&type=script&lang=js"
export * from "./EditIntershipNewsPopup.vue?vue&type=script&lang=js"
import style0 from "./EditIntershipNewsPopup.vue?vue&type=style&index=0&id=63b7c5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7c5a0",
  null
  
)

export default component.exports